import { STORE_TRANSACTION_LOGS } from '../../constants/actionTypes'

const initialState = {}

const finance = (state = initialState, action) => {
  switch (action.type) {
    case STORE_TRANSACTION_LOGS:
      return { ...state, ...action.content }
    default:
      return state
  }
}

export default finance
